import Button, { ButtonProps } from "../Button";
import { UnsupportedChainIdError, useWeb3React } from "@web3-react/core";
import Image from 'next/image';

import { Activity } from "react-feather";
import React, { useEffect } from "react";
import { t } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import {
  useWalletModalToggle,
  useModalOpen,
} from "../../state/application/hooks";
import { ApplicationModal } from "../../state/application/actions";

export default function Web3Connect({
  color = "gray",
  size = "sm",
  className = "",
  ...rest
}: ButtonProps) {
  const { i18n } = useLingui();
  const toggleWalletModal = useWalletModalToggle();
  const { error } = useWeb3React();
  const open = useModalOpen(ApplicationModal.WALLET);

  const keyDownListener = (event) => {
    if (event.code === "Enter") toggleWalletModal();
  };

  useEffect(() => {
    if (error && !open) {
      toggleWalletModal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  return error ? (
    <div
      className="text-xs lg:text-base flex items-center justify-center px-4 py-2 font-semibold zText-1 border-red bg-red-650 hover:bg-opacity-80 border-2"
      onClick={toggleWalletModal}
    >
      <div className="mr-1">
        <Activity className="w-4 h-4" />
      </div>
      {error instanceof UnsupportedChainIdError
        ? i18n._(t`Wrong network`)
        : i18n._(t`Error`)}
    </div>
  ) : (
    <div
      tabIndex={0}
      onKeyDown={(event) => keyDownListener(event)}
      className="focus:outline-none flex items-center space-x-2 bg-gradient-to-r from-[#DB332F] to-[#FF2E29] zText-1 px-6 py-2 rounded-lg place-items-center"
    >
      <Image src="/images/icons/wallet-v2.svg" alt="Wallet" width={26} height={26} />
      <button
        id="connect-wallet"
        onClick={toggleWalletModal}
        className="text-white font-semibold text-sm"
        {...rest}
      >
        Connect Wallet
      </button>
    </div>

  );
}
